<script setup lang="ts">
import { definePage } from 'unplugin-vue-router/runtime'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useStoreData } from '@/stores/data'
import { useStoreAuth } from '@/stores/auth'
import LayoutHeader from '@/layouts/header.vue'

const router = useRouter()
const { t } = useI18n()
const { dataState } = useStoreData()
const { authState } = useStoreAuth()

definePage({
  meta: {
    requireAuth: true
  }
})

/**
 * if the user has only one group,
 * we redirect him to this group
 */
if (dataState.groups?.length === 1) {
  router.push('/group/' + dataState.groups[0].id)
}
</script>

<template>
  <layout-header :display-menu-button="false">
    <main class="max-w-7xl mx-auto p-2 px-4 md:p-4 overflow-auto">
      <h1 class="text-3xl my-4 md:my-8 text-center text-primary">
        {{ t('capel.routes.home.title') }}
      </h1>

      <p class="text-xl text-center">
        {{ t('capel.routes.home.welcomeMessage', [authState?.user?.name]) }}
      </p>

      <h2 class="text-xl mt-8">
        {{ t('capel.routes.home.chooseStructure') }}
      </h2>

      <div class="flex flex-wrap gap-4 mt-8 mx-auto justify-center">
        <template
          v-for="group in dataState.groups"
          :key="group.id"
        >
          <router-link
            :to="'/group/' + group.id"
            class="shadow-md hover:shadow-lg flex flex-col items-center justify-center text-center rounded-md border p-4 hover:underline w-48 h-48 hover:shadow-md text-xl bg-white dark:text-white dark:bg-slate-800"
          >
            <template v-if="group.id === '46a3022d-775b-48c8-8fdc-05ee8b612f19'">
              {{ authState?.user?.name }}
              <span class="text-sm italic">{{ t('capel.groups.' + group.id) }}</span>
            </template>
            <template v-else>
              {{ group.name }}
            </template>
          </router-link>
        </template>
      </div>
    </main>
  </layout-header>
</template>
